import type { ReactNode } from 'react';
import { AdHexMark } from './AdHexMark';
import './match-intro-mobile.css';

type Props = {
  children?: ReactNode;
  progress?: number;
  showLoadBar?: boolean;
};

function AdMark() {
  return (
    <div className="mim__mark" aria-hidden>
      <AdHexMark size={46} />
    </div>
  );
}

/** Mobile match-night intro — same path choice + stadium hero as desktop. */
export function MatchIntroMobile({
  children,
  progress = 1,
  showLoadBar = true,
}: Props) {
  const pct = Math.round(Math.min(1, Math.max(0, progress)) * 100);

  return (
    <div className="mim">
      <div className="mim__cam" aria-hidden>
        <div className="mim__bg" />
        <div className="mim__spot" />
        <div className="mim__vignette" />
      </div>

      <AdMark />

      <div className="mim__rails" aria-hidden>
        <span>Projects</span>
        <span>Experience</span>
        <span>Skills</span>
        <span>Contact</span>
      </div>

      <div className="mim__stage">
        <h1 className="mim__title">
          <span className="mim__title-chrome">The Final</span>
        </h1>
        <p className="mim__sub">Engineering Portfolio</p>
        {children}
      </div>

      {showLoadBar && (
        <div className="mim__load" aria-live="polite">
          <span>Initializing</span>
          <div className="mim__load-track">
            <i style={{ width: `${pct}%` }} />
          </div>
          <strong>{pct}%</strong>
        </div>
      )}

      <div className="mim__flash" aria-hidden />
    </div>
  );
}
